import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {deleteHistory} from '../../modules/chat/chat';
import { LiaRedoAltSolid } from 'react-icons/lia';
import { ReactComponent as IconError } from '../../assets/Icon_error.svg';

import styles from './removeHistoryModal.module.css'

export default function RemoveHistoryModal({isOpenModal, setIsOpenModal, id}) {
    const dispatch = useDispatch();

    const {deleteResponse, deleteErrorResponse} = useSelector(({chat}) => ({
        deleteResponse: chat.deleteResponse,
        deleteErrorResponse: chat.deleteErrorResponse,
    }));

    const onConfirmRemove = () => {
        dispatch(deleteHistory({id}));
    };

    useEffect(() => {
        if (!deleteResponse) return;
        setIsOpenModal(false);
    }, [deleteResponse]);

    return (
        <>
            {!deleteErrorResponse ?
            <div className={styles.containerModal}>
                <h1 className={styles.header}>대화 내역을 삭제하시겠습니까?</h1>
                <div className={styles.containerUserActions}>
                    <div className={styles.buttonArea}>
                        <button className={styles.buttonCancel} onClick={e => setIsOpenModal(false)}>취소</button>
                        <button className={styles.buttonConfirm} onClick={onConfirmRemove}>삭제하기</button>
                    </div>
                </div>
            </div>
            : <div className={styles.containerInlineModal}>
                <div className={styles.messageAreaInline}>
                    <IconError style={{width: '20px', height: '20px'}}/>
                    <h1 className={styles.header}>서버 오류로 인한 대화내역 삭제 실패</h1>
                </div>
                <div className={styles.buttonArea}>
                    <button className={styles.buttonRetry} onClick={onConfirmRemove}>재시도</button>
                    <LiaRedoAltSolid style={{color: 'var(--gray-dark)', strokeWidth: '1.5px'}} onClick={onConfirmRemove}/>
                </div>
            </div>}
        </>
    );
}
